import BackendClient from '../backend-client';
import CatalogResource, { modelFactory } from './model';

export default class CatalogClient extends BackendClient {
  constructor(options = {}) {
    super(modelFactory, options);
  }

  getCatalog = (userId, locationId) => this.req(null, {
    resourceName: 'catalogs',
    params: {
      cnt: userId,
      location: locationId,
    },
  })

  getCatalogCategories = (catalogId, userId, type) => this.req(null, {
    resourceName: 'catalogCategories',
    id: catalogId,
    params: {
      cnt: userId,
      type,
    },
  })

  getCategoryElements = (categoryId, type) => this.req(null, {
    resourceName: 'categoryElements',
    id: categoryId,
    params: {
      type,
    },
  })

  getElement = (elementId, type) => this.req(null, {
    resourceName: 'element',
    id: elementId,
    params: {
      type,
    },
  })

  getElementClone = async (idTicket, elementId) => {
    const response = await this.request('get', `${idTicket}/clone`)(
      { elementId },
      {
        path: 'ticket',
      },
    );
    return this.format(response);
  }
}

export {
  CatalogResource,
};
